import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import FieldInput from 'common/components/FieldInput';
import styles from './styles.module.scss';

const FormForgotPasswordView = ({values}) => {
  return (
    <div className={styles.forgotPassword}>
      <h2>שכחתי ססמה</h2>
      <p className={styles.description}>לאיפוס הססמא אנא הכנס את כתובת האימייל
        המשוייכת לחשבון</p>
      <Form>
        <div className={styles.email}>
          <FieldInput
            fieldId="username"
            value={values.username}
            label="שם משתמש"
            classNames={{
              label: styles.label,
              input: styles.input,
            }}
          />
        </div>
        <button
          type="submit"
          className={styles.buttonSend}>
          <span>אפס ססמה</span>
        </button>
      </Form>
    </div>
  );
};

FormForgotPasswordView.propTypes = {
  values: PropTypes.object
};

export default FormForgotPasswordView;
